module.exports = __webpack_public_path__ + "static/img/GHRlogo.ffc990a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GHRlogo.jpg
// module id = PWgA
// module chunks = 0